import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ServiceBranchOffice, serviceBranchOfficeFiltering} from './service-branch-office.model';
import { serviceOfficeInput } from '../../instution-settings/branch-office/branch-office.model';

export const loadServiceBranchOffices = createAction(
  '[ServiceBranchOffice/API] Load ServiceBranchOffices',
  props<{ serviceBranchOffices: ServiceBranchOffice[] }>()
);

export const addServiceBranchOffice = createAction(
  '[ServiceBranchOffice/API] Add ServiceBranchOffice',
  props<{ serviceBranchOffice: ServiceBranchOffice }>()
);

export const upsertServiceBranchOffice = createAction(
  '[ServiceBranchOffice/API] Upsert ServiceBranchOffice',
  props<{ serviceBranchOffice: ServiceBranchOffice }>()
);

export const addServiceBranchOffices = createAction(
  '[ServiceBranchOffice/API] Add ServiceBranchOffices',
  props<{ serviceBranchOffices: ServiceBranchOffice[] }>()
);

export const upsertServiceBranchOffices = createAction(
  '[ServiceBranchOffice/API] Upsert ServiceBranchOffices',
  props<{ serviceBranchOffices: ServiceBranchOffice[] }>()
);

export const updateServiceBranchOffice = createAction(
  '[ServiceBranchOffice/API] Update ServiceBranchOffice',
  props<{ serviceBranchOffice: Update<ServiceBranchOffice> }>()
);

export const updateServiceBranchOffices = createAction(
  '[ServiceBranchOffice/API] Update ServiceBranchOffices',
  props<{ serviceBranchOffices: Update<ServiceBranchOffice>[] }>()
);

export const deleteServiceBranchOffice = createAction(
  '[ServiceBranchOffice/API] Delete ServiceBranchOffice',
  props<{ id: string }>()
);

export const deleteServiceBranchOffices = createAction(
  '[ServiceBranchOffice/API] Delete ServiceBranchOffices',
  props<{ ids: string[] }>()
);

export const clearServiceBranchOffices = createAction(
  '[ServiceBranchOffice/API] Clear ServiceBranchOffices'
);


// custom actions
export const assignServiceToOfficeBranchMutation = createAction(
  '[BranchOffice/API] assign Service To Office Branch Mutation',
  props<{input: serviceOfficeInput }>()
);

export const getAllOfficeBranch = createAction(
  '[ServiceBranchOffice/API] Get All OfficeBranch',
  props<{filtering: serviceBranchOfficeFiltering}>()
);

export const removeServiceFromOfficeBranchMutation = createAction(
  '[BranchOffice/API] remove Service From Office Branch Mutation',
  props<{input: serviceOfficeInput,id:string }>()
);



